"use client";

import {useMemo} from "react";
import {useSession} from "next-auth/react";
import useGebruiker from "hooks/useGebruiker";

/**
 * Resolves contact-form prefill data from the active session and the user's"namens bedrijf"
 *
 * Returns:
 *  - isLoggedIn: whether a user is currently logged in
 *  - prefill: { companyName, companyLocation, email } pulled from the session
 *  - debiNum: stringified debiteurnummer for the active company, or null
 *  - bedrijfId: internal bedrijf id for the active company, or null
 */
export function useContactPrefill() {
    const {data: session} = useSession();
    const {namensBedrijf} = useGebruiker();

    const ingelogdeGebruiker = session?.user?.ingelogdeGebruiker || null;
    const isLoggedIn = Boolean(ingelogdeGebruiker);
    const company = namensBedrijf ?? ingelogdeGebruiker?.bedrijven?.[0] ?? null;

    const prefill = useMemo(
        () => ({
            companyName: company?.naam ?? "",
            companyLocation: company?.adres ?? "",
            email: ingelogdeGebruiker?.email ?? "",
        }),
        [company, ingelogdeGebruiker],
    );

    const debiNum = useMemo(() => {
        const candidate = company?.debinr ?? company?.debi_num ?? null;
        if (candidate == null || candidate === "") return null;
        return String(candidate);
    }, [company]);

    const bedrijfId = useMemo(() => {
        const candidate = company?.id ?? null;
        if (candidate == null || candidate === "") return null;
        return candidate;
    }, [company]);

    return {isLoggedIn, prefill, debiNum, bedrijfId};
}
